MultiStepForm[1] = {
  first_name: false,
  second_last_name: false,
  last_name: false,
  phone: false,
  email: false,
  personal_code: false,
  agree_terms_and_policy: false,
  agree_to_receive_news_update: false,
  data_proccessing_policy: false,
  // recaptcha: false,
}

const regex_text = /^[a-zA-ZÀ-ÖØ-öø-ÿ\. ]+$/i
const regex_email =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const regex_dni = /^(([KLM]\d{7})|(\d{8}))([A-Z])$/
const regex_cif = /^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/
const regex_nie = /^[XYZ]\d{7,8}[A-Z]$/

const validateNames = (value) => {
  const trimmedValue = value.replace(/\s/g, "")
  return regex_text.test(trimmedValue) && trimmedValue.length >= 3
}

const validatePhone = (value) => {
  return (
    value.length >= 15 && (value.charAt(4) === "6" || value.charAt(4) === "7")
  )
}

const validateEmail = (value) => {
  return regex_email.test(value)
}

const validatePersonalCode = (value) => {
  if (!value) {
    return false
  }

  value = value.toUpperCase().replace(/\s/, "")
  const type = getPersonalCodeType(value)

  if (!type) {
    return false
  }

  switch (type) {
    case "dni":
      return validateDNI(value)
    case "nie":
      return validateNIE(value)
    case "cif":
      return validateCIF(value)
  }
}

const getPersonalCodeType = (value) => {
  if (value.match(regex_dni)) {
    return "dni"
  }
  if (value.match(regex_cif)) {
    return "cif"
  }
  if (value.match(regex_nie)) {
    return "nie"
  }

  return false
}

const validateDNI = (dni) => {
  const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE"
  if (dni[0].match(/[KLM]/)) {
    dni = dni.substr(1)
  }
  const letter = dni_letters.charAt(parseInt(dni, 10) % 23)
  return letter == dni.charAt(dni.length - 1)
}

const validateNIE = (nie) => {
  let nie_prefix = nie.charAt(0)

  switch (nie_prefix) {
    case "X":
      nie_prefix = 0
      break
    case "Y":
      nie_prefix = 1
      break
    case "Z":
      nie_prefix = 2
      break
  }

  return validateDNI(nie_prefix + nie.substr(1))
}

const validateCIF = (cif) => {
  const match = cif.match(regex_cif)
  const letter = match[1],
    number = match[2],
    control = match[3]

  let even_sum = 0
  let odd_sum = 0
  let last_digit = 0
  let n

  for (let i = 0; i < number.length; i++) {
    n = parseInt(number.charAt(i), 10)

    if (i % 2 === 0) {
      n *= 2
      odd_sum += n < 10 ? n : n - 9
    } else {
      even_sum += n
    }
  }

  last_digit = parseInt((even_sum + odd_sum).toString().slice(-1), 10)
  const control_digit = last_digit != 0 ? 10 - last_digit : last_digit
  const control_letter = "JABCDEFGHI".substr(control_digit, 1)

  if (letter.match(/[ABEH]/)) {
    return control == control_digit
  }

  if (letter.match(/[PQSW]/)) {
    return control == control_letter
  }

  return control == control_digit || control == control_letter
}

// const renderRecaptcha = (sitekey = "", retry = 1) => {

//   var recaptchaContainerId = "recaptcha-container";

//   if( isRecaptchaV2Rendered(recaptchaContainerId) ) { // already rendered, reset/reload and exit
//     recaptchaV2Reset();
//     return;
//   }

//   if(!sitekey){ // if sitekey is not set get from form
//     sitekey = jQuery("#form-step-container").data("sitekey")
//   }

//   if (typeof grecaptcha !== "undefined" && jQuery("#" + recaptchaContainerId).length > 0 ) { // check if DOM element is present before rendering reCaptcha
//     grecaptcha.render(recaptchaContainerId, {
//       sitekey: sitekey,
//       callback: recaptchaCallback,
//     })
//   } else {
//     if( retry < 3) {
//       setTimeout(function () {
//         renderRecaptcha(sitekey, retry++)
//       }, 200)
//     }
//   }
// }

const isRecaptchaV2Rendered = (containerId) => {
  var recaptchaContainer = document.getElementById(containerId);
  return recaptchaContainer ? recaptchaContainer.hasChildNodes() : false;
}

const isRecaptchaV2Active = (containerId="recaptcha-container") => {
  return $("#" + containerId).length > 0;
}

const isRecaptchaV3Active = (containerId="recaptcha-container-v3") => {
  return $("#" + containerId).length > 0;
}

const recaptchaV3Validation = (containerId = "recaptcha-container-v3") => {
  return new Promise((resolve, reject) => {
    grecaptcha.ready(function () {
      var container = $("#" + containerId);
      if (container.length) {
        var v3Sitekey = container.data("sitekey");
        grecaptcha
          .execute(v3Sitekey, { action: 'submit' })
          .then(function (token) {
            $(container).find("input[type=hidden]").val(token);
            resolve(); // Resolve the promise when reCAPTCHA validation is complete
          })
          .catch(function (error) {
            reject(error); // Reject the promise if there is an error
          });
      } else {
        reject("Container not found");
      }
    });
  });
};
const recaptchaCallback = () => {
  // var recaptchaV2isActive = isRecaptchaV2Active(),
  //     response = false;

  // if( recaptchaV2isActive ) {
  //   response = grecaptcha.getResponse()
  // }
  const response = true
  if (response) {
    document.getElementById("error_empty_recaptcha").innerHTML = ""
    MultiStepForm[1].recaptcha = true
  } else if (isRecaptchaV3Active()) {
    document.getElementById("error_empty_recaptcha").innerHTML = ""
    MultiStepForm[1].recaptcha = true
  } else {
    jQuery(".field-LeadForm-google-recaptcha").addClass("has-error")
    document.getElementById("error_empty_recaptcha").innerHTML = "Google reCAPTCHA no puede estar vacío."
    MultiStepForm[1].recaptcha = false
  }
}

jQuery(document).ready(function ($) {
  $("body").on("keyup", "#form-input-step-1 input", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    let field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    let success = false

    if (["first_name", "second_last_name", "last_name"].includes(name)) {
      success = validateNames(value)
    }

    if (name == "phone") {
      success = validatePhone(value)
    }

    if (name == "email") {
      success = validateEmail(value)
    }

    if (name == "personal_code") {
      // success = value.length && validatePersonalCode(value)
      success = value.length;
      field = "DNI/NIE"
    }

    if (success) {
      showSuccess(1, name)
    } else {
      showError(1, name, field, value)
    }
  })

  $("body").on("change", "#form-checkbox-step-1 input", function () {
    const value = $(this).val()
    const name = $(this).data("name")

    if ($(this).is(":checked")) {
      showSuccess(1, name)
    } else {
      const text =
        name == "data_proccessing_policy"
          ? "Por favor, acepta Política de privacidad."
          : "Por favor, acepta Términos & Condiciones."
      showError(1, name, "", value, text)
    }
  })

  $("body").on("click", "#submit-button-step-1", function (event) {
    event.preventDefault()

    const uuid = $("#form-step-container").data("uuid")
    localStorage.setItem("form-uuid", uuid)
    submitForm(1)
  })


  //Select all checkbox
  $("body").on("click", "#LeadForm-select_all_policies", function(){
    let checkboxItem = "#form-step-1 :checkbox";
      if(this.checked){
        $(checkboxItem).each(function(){
          $(this).prop('checked', true);
        })
      }else{
        $(checkboxItem).each(function(){
          $(this).prop('checked', false);
        })
      }
  });


  $("body").on('change', "#form-step-1 :checkbox", function(){
    var isAllChecked = true;
    $("#form-step-1 :checkbox").each(function(){
      if (this.id != "LeadForm-select_all_policies" && !this.checked) {
        isAllChecked = false;
        return;
      }
    });

    $('#LeadForm-select_all_policies').prop('checked', isAllChecked);
  });

  //Select all checkbox via label
  $("body").on("click", ".form-group-checkbox .form-checkbox-label", function(e){
    $(this).closest(".form-group-checkbox").find(":checkbox").trigger("click");
  })

  //Show Consent MOdal PopUp code
  // $("body").on("click", ".show_consent_modal", function(e){
  //   e.stopPropagation();
  //   e.preventDefault;
  //   var modalClass = $(this).data("modal");
  //   $(modalClass).addClass("show_modal");
  //   $('html').addClass("not_scroll");
  //   $(".close-button-modal").on("click" , function(e){
  //     $(modalClass).removeClass("show_modal");
  //     $('html').removeClass("not_scroll");
  //   })
  // })

  //Close pop up when clicking outside pop up container
  $(".pop_up_modal_container").on("click", function(){
    $(this).removeClass("show_modal");
    $('html').removeClass("not_scroll");
  })

  $(".confirm-button-close .confirm-terms, .confirm-button-close .confirm-privacy").on("click", function(e){
    if( $("#LeadForm-agree_terms_and_policy").is(':checked') == false ) {
      $("#LeadForm-agree_terms_and_policy").trigger("click");
    }
  })

  $(".confirm-button-close .confirm-financiero, .confirm-button-close .confirm-politica, .confirm-button-close .confirm-leermas").on("click", function(e){
    if( $("#LeadForm-data_proccessing_policy").is(':checked') == false ) {
      $("#LeadForm-data_proccessing_policy").trigger("click");
    }
  })

}) // end jQuery(document).ready